import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const adminMcpServersQueryKey = ["adminMcpServers"];

export function useAdminMcpServers() {
  const { mcpRegistryService } = useDomainServices();

  return useQuery({
    queryKey: adminMcpServersQueryKey,
    queryFn: ({ signal }) =>
      mcpRegistryService.adminListServers({ abortSignal: signal }),
    staleTime: 60_000,
  });
}
